"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "teramo": {
    "d39b264d": [{
      "hkey": "d4c43bc7",
      "slug": "colle-santa-maria-varano",
      "name": "Colle Santa Maria-Varano",
      "primary": true,
      "skipSearch": false
    }],
    "colle-santa-maria": [{
      "hkey": "d4c43bc7",
      "slug": "colle-santa-maria-varano",
      "name": "Colle Santa Maria-Varano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "aa5ead56": [{
      "hkey": "8e2f0f88",
      "slug": "colleatterrato-basso-villa-pavone",
      "name": "Colleatterrato Basso-Villa Pavone",
      "primary": true,
      "skipSearch": false
    }],
    "colleatterrato-basso": [{
      "hkey": "8e2f0f88",
      "slug": "colleatterrato-basso-villa-pavone",
      "name": "Colleatterrato Basso-Villa Pavone",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "79f15d54": [{
      "hkey": "48e0ac1e",
      "slug": "teramo",
      "name": "Teramo",
      "primary": true,
      "skipSearch": false
    }],
    "estrema-periferia": [{
      "hkey": "48e0ac1e",
      "slug": "teramo",
      "name": "Teramo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "fb14df9f": [{
      "hkey": "473b40a6",
      "slug": "poggio-cono-poggio-san-vittorino-secciola",
      "name": "Poggio Cono-Poggio San Vittorino-Secciola",
      "primary": true,
      "skipSearch": false
    }],
    "poggio-cono": [{
      "hkey": "473b40a6",
      "slug": "poggio-cono-poggio-san-vittorino-secciola",
      "name": "Poggio Cono-Poggio San Vittorino-Secciola",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "ffdd8106": [{
      "hkey": "473b40a6",
      "slug": "poggio-cono-poggio-san-vittorino-secciola",
      "name": "Poggio Cono-Poggio San Vittorino-Secciola",
      "primary": true,
      "skipSearch": false
    }],
    "poggio-san-vittorino": [{
      "hkey": "473b40a6",
      "slug": "poggio-cono-poggio-san-vittorino-secciola",
      "name": "Poggio Cono-Poggio San Vittorino-Secciola",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "teramo"
    }],
    "a1b7a648": [{
      "hkey": "b8058925",
      "slug": "gammarana-stazione",
      "name": "Gammarana-Stazione",
      "primary": true,
      "skipSearch": false
    }],
    "prima-periferia": [{
      "hkey": "b8058925",
      "slug": "gammarana-stazione",
      "name": "Gammarana-Stazione",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "teramo"
    }],
    "9cb6ffc4": [{
      "hkey": "58412bfd",
      "slug": "castello-viale-bovio",
      "name": "Castello-Viale Bovio",
      "primary": true,
      "skipSearch": false
    }],
    "semicentro": [{
      "hkey": "58412bfd",
      "slug": "castello-viale-bovio",
      "name": "Castello-Viale Bovio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "teramo"
    }],
    "e34e1db9": [{
      "hkey": "47d2a163",
      "slug": "tordinia-villa-ripa",
      "name": "Tordinia-Villa Ripa",
      "primary": true,
      "skipSearch": false
    }],
    "tordinia": [{
      "hkey": "47d2a163",
      "slug": "tordinia-villa-ripa",
      "name": "Tordinia-Villa Ripa",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "09f50922": [{
      "hkey": "d4c43bc7",
      "slug": "colle-santa-maria-varano",
      "name": "Colle Santa Maria-Varano",
      "primary": true,
      "skipSearch": false
    }],
    "varano": [{
      "hkey": "d4c43bc7",
      "slug": "colle-santa-maria-varano",
      "name": "Colle Santa Maria-Varano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "teramo"
    }],
    "0e69a6c3": [{
      "hkey": "47d2a163",
      "slug": "tordinia-villa-ripa",
      "name": "Tordinia-Villa Ripa",
      "primary": true,
      "skipSearch": false
    }],
    "villa-ripa": [{
      "hkey": "47d2a163",
      "slug": "tordinia-villa-ripa",
      "name": "Tordinia-Villa Ripa",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "teramo"
    }]
  }
};
exports["default"] = _default;